// extracted by mini-css-extract-plugin
module.exports = {"container":"_2QmL0vLc7_7XxFeK4bkI5a"};